export class BusinessOrdersStatusKpi {
    public totalOrdersCount: number = 0;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }
}
